import { parseClusterResponse } from "common/api";

const warningBillingDisabledRE = /%WARN-ENOENT: Billing API disabled/;

const labelAndValueFrom = (row) => {
  const [label, value] = row.trim().split(/: /);
  return { label, value };
};

const extractFacts = (input) =>
  input
    .trim("\n")
    .split("\n")
    .flatMap((row) => (row.length === 0 ? [] : [labelAndValueFrom(row)]));

export const parseBillingStatus = (input) =>
  input.match(warningBillingDisabledRE) ? null : extractFacts(input);

export const isSyncDone = (facts) => {
  if(!facts){
    return false;
  }

  const syncEndedFact = facts.find(({ label }) => label === "Sync in progress");
  return syncEndedFact === undefined || syncEndedFact.value !== "no"
    ? false
    : true;
};

const parseMoment = (input) => new Date(input.trim("\n"));

const requestBillingStatus = () =>
  ifCl.run(`show api billing status detail`).then(response => {
    if(response.match('Billing API disabled')){
      return null;
    }

    return parseClusterResponse(response, parseBillingStatus)});

export const requestMoment = () => ifCl.run("show system date").then(parseMoment);

export const requestFactsAndMoment = () =>
  Promise.all([requestMoment(), requestBillingStatus()]).then(
    ([moment, facts]) => ({
      moment,
      facts,
    })
  );

const disconnectAndConnect = () =>
  ifCl
    .run(`api billing disconnect`)
    .then(() => ifCl.run("api billing connect"));

const warnBusyAndReturnData = (callback, data) => {
  try {
    callback();
  } catch (error) {
    console.warn("failed to run warning callback");
  }
  return data;
};

export const reconnect = (warningCallback) =>
  requestFactsAndMoment().then(({ moment, facts }) => {
    const ready = facts !== null ? Object.values(facts).every(isSyncDone) : false;
    return ready === true
      ? disconnectAndConnect().then(requestFactsAndMoment)
      : warnBusyAndReturnData(warningCallback, { ready, moment, facts });
  });
